import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
	selector: 'app-input-disabled',
	templateUrl: './input-disabled.component.html',
	styleUrls: ['./input-disabled.component.scss']
})
export class InputDisabledComponent implements OnInit {
	@Input() public placeHolderTextBox: string = 'Enter text here';
	@Input() public control: FormControl | AbstractControl;
	@Input() public disabled: boolean = true;
	private unsubscriber$ = new Subject<void>();

	constructor() {}

	public ngOnInit(): void {}

	public ngOnDestroy(): void {
		this.unsubscriber$.next();
		this.unsubscriber$.complete();
	}
}
